<div class="timed-marker-menu-panel">
  @if (showSettings()) {
    <dv-button
      [dvMenuTriggerFor]="settings"
      [disabled]="disableMenu()"
      [tooltip]="'TimedMarkerMapMenuPanel.SettingsBtnTooltip' | translate"
      class="timed-marker-menu-panel__settings"
      icon="settings"></dv-button>
  }
  <div class="timed-marker-menu-panel__other-settings">
    <ng-content></ng-content>
  </div>

  <div class="timed-marker-menu-panel__legend">
    @if (showLocationsLegend()) {
      <div class="timed-marker-menu-panel__legend--item">
        <div class="item">
          <div class="item__location-icon">
            <img [src]="'./assets/locations/active.svg'" />
          </div>
          <div>
            <p class="item__text">
              {{ 'OnCallStatus.ONCALL' | translate }}
            </p>
          </div>
        </div>
      </div>
      <div class="timed-marker-menu-panel__legend--item">
        <div class="item">
          <div class="item__location-icon">
            <img [src]="'./assets/locations/idle.svg'" />
          </div>
          <div>
            <p class="item__text">
              {{ 'OnCallStatus.IDLE' | translate }}
            </p>
          </div>
        </div>
      </div>
      <div class="timed-marker-menu-panel__legend--item">
        <div class="item">
          <div class="item__location-icon">
            <img [src]="'./assets/locations/off.svg'" />
          </div>
          <div>
            <p class="item__text">
              {{ 'OnCallStatus.NOTONCALL' | translate }}
            </p>
          </div>
        </div>
      </div>
      <div class="separator"></div>
    }

    @if (showMaintainersLegend()) {
      @for (legendItem of timedMaintainerData; track legendItem) {
        <div class="timed-marker-menu-panel__legend--item">
          <div class="item">
            <div class="item__icon">
              <img [src]="legendItem.iconUrl" />
            </div>
            <div>
              <p class="item__text">{{ legendItem.text }}</p>
            </div>
          </div>
        </div>
      }
      <div class="separator"></div>
    }

    @if (showGeofenceLegend()) {
      <div class="timed-marker-menu-panel__legend--item">
        <div class="item">
          <div class="item__icon" [style.background-color]="'blue'"></div>
          <div>
            <p class="item__text">
              {{ 'Fleet.TemporaryGeofence.LegendLabel' | translate }}
            </p>
          </div>
        </div>
      </div>
      <div class="timed-marker-menu-panel__legend--item">
        <div class="item">
          <div class="item__icon" [style.background-color]="'orange'"></div>
          <div>
            <p class="item__text">
              {{ 'Fleet.PermanentGeofence.LegendLabel' | translate }}
            </p>
          </div>
        </div>
      </div>
      <div class="separator"></div>
    }
    @for (legendItem of timedMarkerData; track legendItem) {
      <div class="timed-marker-menu-panel__legend--item">
        <div class="item">
          <div
            class="item__icon"
            [style.background-color]="
              showCarIcons() ? '' : legendItem.backgroundColor
            ">
            @if (showCarIcons()) {
              <img [src]="legendItem.iconUrl" [class.car]="showCarIcons()" />
            }
          </div>
          <div>
            <p class="item__text">{{ legendItem.text }}</p>
          </div>
        </div>
      </div>
    }
  </div>
  @if (showAddressSearch()) {
    <div class="timed-marker-menu-panel__search-wrapper">
      <dv-dynamic-form
        class="timed-marker-menu-panel__search"
        [elements]="searchElement | translateElements"
        [formGroup]="formGroup">
      </dv-dynamic-form>
      <div class="dv-icons timed-marker-menu-panel__search-icon">
        <span>search</span>
      </div>
    </div>
  }
  @if (slideToggleLabel()) {
    <div class="timed-marker-menu-panel__slide-toggle">
      <dv-dynamic-form
        [elements]="slideToggleElement | translateElements"
        [formGroup]="formGroup">
      </dv-dynamic-form>
    </div>
  }
</div>

<dv-menu #settings [isOpen]="false">
  <div class="settings">
    <dv-dynamic-form
      formTitle="{{ 'Main.Settings' | translate | uppercase }}"
      [elements]="mainSettingsElements | translateElements"
      [formGroup]="formGroup">
    </dv-dynamic-form>
    @if (!hideGroupMarkers()) {
      <hr class="form-divider" />
      <dv-dynamic-form
        [elements]="clusteringFormElements | translateElements"
        [formGroup]="formGroup"></dv-dynamic-form>
    }
    @if (customFormElements && customForm) {
      <hr class="form-divider" />
      <dv-dynamic-form
        [elements]="customFormElements | translateElements"
        [formGroup]="customForm"></dv-dynamic-form>
    }
  </div>
</dv-menu>
